import React, { useEffect, useState } from "react";

import TestMatchTabs from "./TestMatchTabs";
import ScoreCard from "./ScoreCard";
import { loadStyles } from "../../utils/cssLoader";
import { useCricketScorecardSocket } from "../../hooks/useCricketScorecardSocket";

const CricketScorecardTable = ({
  ServerData,
  loadCSS = true,
  dataClient = false,
  title,
  dictionary = {},
  socketUrl,
  matchId
}) => {
  const [clientData, setClientData] = useState(null);
  const matchData = dataClient ? clientData : ServerData;
  const socketData = useCricketScorecardSocket(socketUrl, matchId);
  const scorecardData = socketData ?? matchData;

  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data;
      setActive(items[items.length - 1]?.value);
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("cricketmatch");
    }
  }, [loadCSS]);

  const homeTeamLineup = scorecardData?.data?.[0];
  const awayTeamLineup = scorecardData?.data?.[1];
  const homeTeamLineup2 = scorecardData?.data?.[2];
  const awayTeamLineup2 = scorecardData?.data?.[3];

  const getScoreCardData = () => {
    switch (active) {
      case "home":
        return homeTeamLineup;
      case "home2":
        return homeTeamLineup2;
      case "away":
        return awayTeamLineup;
      case "away2":
        return awayTeamLineup2;
      default:
        break;
    }
  };

  const items = [
    homeTeamLineup && {
      value: "home",
      label: homeTeamLineup?.team?.nm + (homeTeamLineup2 ? " 1st Inn" : ""),
    },
    awayTeamLineup && {
      value: "away",
      label: awayTeamLineup?.team?.nm + (awayTeamLineup2 ? " 1st Inn" : ""),
    },
    homeTeamLineup2 && {
      value: "home2",
      label: homeTeamLineup2?.team?.nm + " 2nd Inn",
    },
    awayTeamLineup2 && {
      value: "away2",
      label: awayTeamLineup2?.team?.nm + " 2nd Inn",
    },
  ].filter(Boolean);
  const [active, setActive] = useState(
    items[items.length - 1]?.value || undefined
  );

  useEffect(() => {
    if (!active && items.length > 0) {
      setActive(items[items.length - 1].value);
    }
  }, [items, active]);
  return (
    <>
      {title ? <h1>{title}</h1> : null}
      <TestMatchTabs items={items} activeItem={active} onClick={setActive} />
      <ScoreCard data={getScoreCardData()} dictionary={dictionary} />
    </>
  );
};

export default CricketScorecardTable;
